// @vendors
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// @components
import ProductController from 'components/ProductController/ProductController';
import { OKButton } from 'commonsComponents/OKButton';

// @constants
const {
  INPUT,
  AMOUNT,
  TOGGLE,
} = require('constants/index');

// @styles
require('./ListProducts.scss');

class ListProducts extends Component {

  constructor(props) {
    super(props);

    this.state = {
      oldPostControllers: null,
      newPostControllers: null,
      changedPostControllers: [],
      saveButtonDisabled: true
    };
  }

  componentDidMount() {
    this.buildPostObject();
  }

  componentDidUpdate(prevProps){
   if (prevProps.products !== this.props.products) {
     this.buildPostObject(); // If user saves changes, we update state with saved values
   }
  }

  comparePosts = () => {
    const { oldPostControllers, newPostControllers } = this.state;
    let changedPostControllers = [];
    let toggleHasChange = false;
    let amountHasChange = false
    let hasValidAmount = true;
    let allAmountsValid = true;

    for (let o = 0; o < oldPostControllers.length; o +=1) {
      toggleHasChange = false;
      amountHasChange = false
      hasValidAmount = true;
      for (let i = 0; i < oldPostControllers[o].length; i += 1) {
        toggleHasChange = (oldPostControllers[o][i].enabled !== newPostControllers[o][i].enabled);
        if (oldPostControllers[o][i] && oldPostControllers[o][i].controllers) {
          for (let j = 0; j < oldPostControllers[o][i].controllers.length; j += 1) {
            if (oldPostControllers[o][i].controllers[j].type === AMOUNT) {
              hasValidAmount = (Number(newPostControllers[o][i].controllers[j].amount) >= Number(newPostControllers[o][i].controllers[j].minAmount));
              amountHasChange = (oldPostControllers[o][i].controllers[j].amount !== Number(newPostControllers[o][i].controllers[j].amount));
            }
          }
        }
        //Only changes will be send to back
        //If user changes toggle, we send to back toggle change only
        if((!amountHasChange && toggleHasChange) || (toggleHasChange && amountHasChange && !newPostControllers[o][i].enabled)){
          changedPostControllers.push({ id: newPostControllers[o][i].id, enabled: newPostControllers[o][i].enabled });
        }
        else if(amountHasChange && hasValidAmount){ changedPostControllers.push(newPostControllers[o][i]); }
        else if(amountHasChange && !hasValidAmount && newPostControllers[o][i].enabled){ allAmountsValid = false; }
      }
    }
    this.setState({
      changedPostControllers: changedPostControllers,
      saveButtonDisabled: (changedPostControllers.length === 0 || !allAmountsValid)
    })
  }

  handleControllerValue = (id, type, newValue) => {
    const { newPostControllers } = this.state;
    let indexChange = 0;
    let indexAmountInput = 0;
    let handleNewPostControllers = newPostControllers;
    let indexParent = 0;
    let indexTypeController

    if (type === TOGGLE) {
      newPostControllers.map((newP, indexP) => {
        newP.map((controllerEnabled, index) => {
          if(controllerEnabled.id === id) {
            indexChange = index;
            indexParent = indexP
          }
        })
      });
      handleNewPostControllers[indexParent][indexChange].enabled = newValue;

    } else if (type === INPUT) {
      newPostControllers.map((newP, indexP) => {
        newP.map((controllerInformation, indexA) => {
          controllerInformation.controllers.map((cont, indexT) => {
            if(cont.type === AMOUNT && cont.id === id) {
              indexParent = indexP;
              indexAmountInput = indexA;
              indexTypeController = indexT;
            }
          })
        });
      });
      handleNewPostControllers[indexParent][indexAmountInput].controllers[indexTypeController].amount = newValue;
    }

    this.setState({
      newPostControllers: handleNewPostControllers
    }, () => {
      this.comparePosts();
    })
  };

  buildControllersObject = (controllers) => {
    const listControllers = controllers.map((controller) => {
      let minAmount = { minAmount: controller.minAmount };
      return (
        {
          "amount": controller.amount,
          "id": controller.id,
          "type": controller.type,
          ...minAmount
        }
      )
    })
    return listControllers;
  }

  buildPostObject = () => {
    const { products } = this.props;

    const postObject = products.map((category) => {
      return category.notifications.map((notification) => {
        return (
          {
            "controllers": this.buildControllersObject(notification.controllers),
            "enabled": notification.enabled,
            "id": notification.id
          }
        )
      })
    });

    this.setState({
      oldPostControllers: JSON.parse(JSON.stringify(postObject.filter(post => post.length > 0))),
      newPostControllers: JSON.parse(JSON.stringify(postObject.filter(post => post.length > 0))),
      saveButtonDisabled: true
    })
  }

  buildProduct = (notifications) => {
    const { formatText } = this.props;
    const notificationList = notifications.map((notification, index) => {
      return (
        <ProductController
          key={index.toString()}
          callback={this.handleControllerValue}
          controllers={notification.controllers}
          formatText={formatText}
          isEnabled={notification.enabled}
          title={notification.title}
          description={notification.description}
          idParent={notification.id}
        />
      );
    });
    return notificationList;
  };

  buildProductslist = () => {
    const { products, formatText } = this.props;

    const listProducts = products.map((product, index) => {
      const cardStyle = classNames(
        'list-products__card col-md-12',
        {
          '-no-border': formatText(`notificationManagement-${product.title}`),
        },
      );

      return (
        <div className={cardStyle} key={index.toString()}>
          {product.title && (
            <div className="list-products__card__title">
              <span>
                {formatText(`notificationManagement-${product.title}`)}
              </span>
            </div>
          )
          }
          <div>{this.buildProduct(product.notifications)}</div>
        </div>
      );
    });

    return listProducts;
  };

  postNewsControllers = () => {
    this.props.handleController(this.state.changedPostControllers);
  }

  render() {
    const { formatText } = this.props;
    const { saveButtonDisabled } = this.state;
    return (
      <div className="list-products row">
        {this.buildProductslist()}
        <div className="list-products__button col-xs-12">
          <OKButton modifier="primary" disabled={saveButtonDisabled} onClick={() => this.postNewsControllers()}>
            {formatText('notificationManagement-saveChanges')}
          </OKButton>
        </div>
      </div>
    );
  }
};

ListProducts.propTypes = {
  products: PropTypes.string.isRequired,
  handleController: PropTypes.func.isRequired,
  formatText: PropTypes.func.isRequired,
};

export default ListProducts;
